import request from '@/utils/request';

//科研资源列表
export const getScientificResourceList = (data) => {
    return request({
        url: '/api/resources/list',
        method: 'post',
				data
    });
};

//添加或者修改科研资源
export const addOrEditScientificResource = (data) => {
    return request({
        url: '/api/resources/saveOrUpdate',
        method: 'post',
				data
    });
};

//删除科研资源
export const delScientificResource = (id) => {
    return request({
        url: '/api/resources/del/'+id,
        method: 'delete',
    });
};
